import { clsx } from 'clsx';
import { extendTailwindMerge, validators } from 'tailwind-merge';

// This validates our custom tailwind font sizes and max-widths so they are merged correctly.// @link: https://github.com/dcastil/tailwind-merge/discussions/169
const twMerge = extendTailwindMerge({
	extend: {
		classGroups: {
			'font-size': [
				{
					text: [{ body: ['', 'xs', 'sm'] }, { heading: ['', validators.isTshirtSize] }, 'label-xs', 'label'],
				},
			],
			'max-w': [
				{
					'max-w': [validators.isTshirtSize, validators.isArbitraryValue, 'layout-compact'],
				},
			],
		},
	},
});

declare namespace classNames {
	type Value = string | number | boolean | undefined | null;
	type Mapping = Record<string, unknown>;
	type ArgumentArray = Array<Argument>;
	type Argument = Value | Mapping | ArgumentArray;
}

// this function merges the popular clsx library with twMerge so we can combine them in one function call
// it allows you to add conditional classes, and the resulting tailwind classes will be filters to resolve for
// potential issues based on the order of the generated tailwind css file
export function classNames(...args: classNames.ArgumentArray): string {
	return twMerge(clsx(...args));
}
